module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Loss of Earnings\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Disability Working Allowance",
      "store-key": "ploeDisabilityWorkingAllowance",
      "show-Header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Employment and Support Allowance",
      "store-key": "ploeEmploymentSupportAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Incapacity Benefit",
      "store-key": "ploeIncapacityBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Income Support",
      "store-key": "ploeIncomeSupport"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Industrial Injuries Disablement Benefit",
      "store-key": "ploeIndustrialInjuriesDisablementBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Invalidity Pension",
      "store-key": "ploeInvalidityPension"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Invalidity Allowance",
      "store-key": "ploeInvalidityAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Jobseeker’s Allowance",
      "store-key": "ploeJobseekersAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Reduced Earnings Allowance",
      "store-key": "ploeReducedEarningsAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Severe Disablement Allowances",
      "store-key": "ploeSevereDisablementAllowance"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Sickness Benefit",
      "store-key": "ploeSicknessBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Statutory Sick Pay paid before 6 April 1994",
      "store-key": "ploeStatutorySickPay"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Unemployability Supplement",
      "store-key": "ploeUnemployabilitySupplement"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Unemployment Benefit",
      "store-key": "ploeUnemploymentBenefit"
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "Past Loss of Earnings",
      "subtitle": "Universal Credit",
      "store-key": "ploeUniversalCredit",
      "is-last": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dda71b88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/cru-benefits/PastLossOfEarnings.vue
// module id = 1821
// module chunks = 0